<template>
  <!-- This component is a wrapper around Bootstrap Vue's BCard that provides a floating title and allows for custom styling through props and attributes. It accepts a 'title' prop for the floating title text and a 'maxWidth' prop to control the maximum width of the card. The card's border can be customized by passing a class through $attrs.class, with a default of 'border' if no class is provided. -->
  <div class="card-with-floating-title" :style="containerStyle">
    <span v-if="title" class="floating-card-title">{{ title }}</span>
    <BCard v-bind="$attrs" :class="cardClass">
      <slot />
    </BCard>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue-next";

export default {
  name: "bPanel",
  components: {
    BCard,
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: "",
    },
    maxWidth: {
      type: String,
      default: "24rem",
    },
  },
  computed: {
    containerStyle() {
      return {
        maxWidth: this.maxWidth,
      };
    },
    cardClass() {
      // Default border class, but allow override through $attrs.class
      return this.$attrs.class || "border";
    },
  },
};
</script>

<style scoped>
.card-with-floating-title {
  position: relative;
  margin-top: 12px;
}

.floating-card-title {
  position: absolute;
  top: -8px;
  left: 16px;
  background: white;
  padding: 0 6px;
  font-size: 0.875rem;
  font-weight: 500;
  z-index: 10;
  color: #495057;
}
</style>
